import axios from 'axios';
import { getEnvVariable } from '../../utils/envUtils';
/** Logrocket gdpr inclusion/exclusion api
 * Connects to our Logrocket configuration to include/exclude users from logrocket tracking
 * uses LFG org slug (constant) and app variables for API KEY & APP Name
 */
var ORGANIZATION_SLUG = 'o1n3rt';
var APP_SLUG = getEnvVariable('LOGROCKET_APP_SLUG');
var LOGROCKET_API_KEY = getEnvVariable('LOGROCKET_API_KEY');
export var optOutOfTracking = function (userEmail) {
  var url = "https://api.logrocket.com/v1/orgs/".concat(ORGANIZATION_SLUG, "/apps/").concat(APP_SLUG, "/gdpr/exclusion/");
  var requestBody = {
    email: userEmail
  };
  return axios.post(url, requestBody, {
    headers: {
      Authorization: "Token ".concat(LOGROCKET_API_KEY),
      'Content-Type': 'application/json'
    }
  });
};
export var optIntoTracking = function (userEmail) {
  var url = "https://api.logrocket.com/v1/orgs/".concat(ORGANIZATION_SLUG, "/apps/").concat(APP_SLUG, "/gdpr/inclusion/");
  var requestBody = {
    email: userEmail
  };
  return axios.post(url, requestBody, {
    headers: {
      Authorization: "Token ".concat(LOGROCKET_API_KEY),
      'Content-Type': 'application/json'
    }
  });
};